const EnumTipoParametroRelatorio = {
    Inteiro: 1,
    Decimal: 2,
    Texto: 3,
    Data: 4,
    DataHora: 5,
    Logico: 6,
    Tabela: 7,
    Consulta: 8,
    ConsultaCheckbox: 9
};
  
export default EnumTipoParametroRelatorio;
  